import { Button, Grid, TextField, useMediaQuery, useTheme } from '@mui/material'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

export enum LocalStorageKeys {
  HOTEL_PATH = 'hic-portal-hotel-path',
}

function TemporaryHomePage() {
  const navigate = useNavigate()

  const theme = useTheme()
  const isSm = useMediaQuery(theme.breakpoints.up('sm'))
  const [hotelPath, setHotelPath] = useState<string>('')

  useEffect(() => {
    const storageHotelPath = localStorage.getItem(LocalStorageKeys.HOTEL_PATH)
    if (storageHotelPath) {
      setHotelPath(storageHotelPath)
    }
  }, [setHotelPath])


  useEffect(() => {
    localStorage.setItem(LocalStorageKeys.HOTEL_PATH, hotelPath)
  }, [hotelPath])


  return (
    <Grid container alignItems="center" justifyContent="center" height="100%">
      <Grid item container spacing={1} alignItems="center" justifyContent="center" mr={1} ml={1} maxWidth={'650px'}>
        <Grid item xs={12} sm={6}>
          {/* For localhost you can use "hotel-prova", it is the property of Andrei or you can change the base_url of your property on DB */}
          <Button variant="outlined" disabled={!hotelPath} onClick={() => navigate(`/booking-engine${hotelPath ? '/' + hotelPath : ''}`)} fullWidth>
            Booking Engine
          </Button>
        </Grid>
        <Grid item xs={12} sm={6} mb={!isSm ? 2 : 0}>
          <TextField fullWidth size="small" placeholder="Hotel Path" value={hotelPath} onChange={(e) => setHotelPath(e.currentTarget.value)} />
        </Grid>
      </Grid>
    </Grid>
  )
}

export default TemporaryHomePage
